import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getFormulariosPresentacion } from "../../../../redux/actions/resolucion";
import {
  clearVisualizacion,
  visualizarCertificadoPresentacion,
  visualizarFormularioPresentado,
} from "../../../../redux/actions/establecimiento";
import ViewDialog from "../../establecimientos/estadoEstablecimiento/dialogs/ViewDialog";
import DetallePresentacionRes81 from "./DetallePresentacionRes81";

const DetallePresentacionRes81Container = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const presentacion = location.state;

  const formulariosPresentacion = useSelector((state) => state.resolucion.formulariosPresentacion);
  const visualizacion = useSelector((state) => state.establecimiento.viewFile?.base64);

  const [viewDialogTitle, setViewDialogTitle] = useState("");
  const [isModalViewOpen, setIsModalViewOpen] = useState(false);

  useEffect(() => {
    const idPresentacion415 = presentacion?.idPresentacion415;
    if (idPresentacion415) dispatch(getFormulariosPresentacion(idPresentacion415));
  }, [presentacion, dispatch]);

  const handleVolver = () => navigate("/prevencion/resolucion-81");

  const handleVerFormulario = (formulario) => {
    setViewDialogTitle("Formularios presentados");
    setIsModalViewOpen(true);
    dispatch(visualizarFormularioPresentado(formulario?.idDDJJ415, 15));
  };

  const handleEditarFormulario = (formulario) => {

    navigate("/prevencion/resolucion-81/form", {
      state: {
        idFormulario: formulario?.idDDJJ415,
        idDependenciaEmpleador: formulario?.idDependenciaEmpleador,
        numeroMuestra: presentacion?.numeroMuestra ?? presentacion?.nroMuestra,
        presentacion: presentacion
      }
    });
  };

  const handleCertificado = (formulario) => {
    setViewDialogTitle("Certificado de presentación");
    setIsModalViewOpen(true);
    dispatch(visualizarCertificadoPresentacion(formulario?.idDDJJ415));
  };

  const handleNuevoFormulario = () => {
    navigate("/prevencion/resolucion-81/form", {
      state: {
        numeroMuestra: presentacion?.numeroMuestra ?? presentacion?.nroMuestra,
        presentacion: presentacion
      }
    });
  };

  const showNuevoFormulario = presentacion?.estado === "Iniciada" || presentacion?.descripcionEstado === "Iniciada" || presentacion?.nombreEstado === "Iniciada";

  return (
    <>
      <DetallePresentacionRes81
        presentacion={presentacion}
        formulariosPresentacion={formulariosPresentacion}
        handleVolver={handleVolver}
        handleVerFormulario={handleVerFormulario}
        handleEditarFormulario={handleEditarFormulario}
        handleCertificado={handleCertificado}
        handleNuevoFormulario={handleNuevoFormulario}
        showNuevoFormulario={showNuevoFormulario}
      />
      <ViewDialog
        open={isModalViewOpen}
        title={viewDialogTitle}
        file={visualizacion}
        onClose={() => {
          dispatch(clearVisualizacion());
          setIsModalViewOpen(false);
        }}
      />
    </>
  );
};

export default DetallePresentacionRes81Container;
